export const EXPERIMENT_NO_ADS = "noAds";
export const EXPERIMENT_ROTATE = "rotate";
export const EXPERIMENT_TEXAS_SLATE = "texasSlate";
export const EXPERIMENT_FULLSCREEN_RECOMBEE = "001_recombee-full-screen-experiment";
export const EXPERIMENT_RECOMBEE_TRENDING_FEED = "003_recombee-trending-experiment";

export const VARIANT_FS_RECOMBEE = "full-screen-recombee";
export const VARIANT_FS_NON_RECOMBEE = "full-screen-non-recombee";
export const VARIANT_NON_FS_RECOMBEE = "non-full-screen-recombee";
export const VARIANT_NON_FS_NON_RECOMBEE = "non-full-screen-non-recombee";

export const VARIANT_CONTROL = "control";
export const VARIANT_TREATMENT = "treatment";

export const FULLSCREEN_RECOMBEE_VARIANT_LIST = [
  {
    label: VARIANT_FS_RECOMBEE,
    value: VARIANT_FS_RECOMBEE
  },
  {
    label: VARIANT_FS_NON_RECOMBEE,
    value: VARIANT_FS_NON_RECOMBEE
  },
  {
    label: VARIANT_NON_FS_RECOMBEE,
    value: VARIANT_NON_FS_RECOMBEE
  },
  {
    label: VARIANT_NON_FS_NON_RECOMBEE,
    value: VARIANT_NON_FS_NON_RECOMBEE
  }
];

export const RECOMBEE_TRENDING_FEED_VARIANT_LIST = [
  {
    label: VARIANT_TREATMENT,
    value: VARIANT_TREATMENT
  },
  {
    label: VARIANT_CONTROL,
    value: VARIANT_CONTROL
  }
];
